// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  ITukApi,
  ITukApiRequest,
  ITukApiGetAllAttrs,
  ITukApiGetAllResponse,
  ITukApiGetAttrs,
  ITukApiGetResponse,
  ITukApiSaveAttrs,
  ITukApiSaveResponse,
} from 'interfaces/back-office/content-management/tuk/tuk/tuk-api.interface'
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class TukApi extends BaseApi<ITukApi> implements ITukApiRequest {
  readonly url = ApiConstant.CONTENT_TUK_URL
  private tukUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get tuk list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ITukApiGetAllAttrs} payload
   *
   * @return {Promise<ITukApiGetAllResponse>} Promise<ITukApiGetAllResponse>
   */
  async contentTuk_getTukList(payload: ITukApiGetAllAttrs): Promise<ITukApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.tukUrl}/list`, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get tuk
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ITukApiGetAttrs} payload
   *
   * @return {Promise<ITukApiGetResponse>} Promise<ITukApiGetResponse>
   */
  async contentTuk_getTuk(payload: ITukApiGetAttrs): Promise<ITukApiGetResponse> {
    try {
      const response = await this.POST(`${this.tukUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save tuk
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {ITukApiSaveAttrs} payload
   *
   * @return {Promise<ITukApiSaveResponse>} Promise<ITukApiSaveResponse>
   */
  async contentTuk_saveTuk(payload: ITukApiSaveAttrs): Promise<ITukApiSaveResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id ? `${this.tukUrl}/update/${payload.params.id}` : `${this.tukUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
